/**
 * Store Dossiers
 */
export default {
    state: {
        regimesTva: ['MRM', 'MRT', 'N/C', 'RS'],
        programmesTypeRent: false,
        retro: [],
        retro_non: 0,
        retro_une_fois: 1,
        retro_recurrent: 2,
        retro_siblu: 3,
    },

    mutations: {
        setProgrammesTypeRent: function (state, programmesTypeRent) {
            state.programmesTypeRent = programmesTypeRent
        }
    },

    actions: {
        initTypesProgrammes: function (context, id) {
            axios.get('/api/dossiers', { params: { id, programme_type: ['Habitation', 'Immeuble']}}).then(response => {
                context.commit('setProgrammesTypeRent', response.data.data.length > 0)
            })
        }
    },

    getters: {
        isProgrammesTypeRent: state => state.programmesTypeRent,

        /**
         * Liste d'options de clôtures
         */
        optionsClotures: () => {
            let month = moment('0001-01-01')
            let monthesOptions = [{label: '', value: ''}]

            for (let i = 0; i < 12; i++, month = month.clone().add(1, 'month').endOf('month')) {
                monthesOptions.push({label: month.format('DD/MM'), value: month.format('YYYY-MM-DD')})
            }

            return monthesOptions
        },

        optionsRegimesTVA: state => {
            return state.regimesTva.map(regime => ({label: regime, value: regime}))
        },

        optionsRetro: () => {
            return [
                { value: 0, label: 'Non' },
                { value: 1, label: 'Une fois' },
                { value: 2, label: 'Récurrent'}
            ]
        },

        optionsTypesIndivisions: () => {
            return [
                { value: 'EURL', label: 'EURL' },
                { value: 'Indivision', label: 'Indivision' },
                { value: 'SARL', label: 'SARL' },
                { value: 'SAS', label: 'SAS' },
                { value: 'SCI', label: 'SCI' },
                { value: 'SDF', label: 'SDF' },
                { value: 'SNC', label: 'SNC' },
            ]
        },

        optionsTypeDossier: () => {
            return [
                { value: 'dossier', label: 'Dossier' },
                { value: 'foncier', label: 'Foncier' },
            ]
        },

        optionsRetroType: () => {
            return [
                { label: 'Chèque cadeau', value: 'Chèque cadeau' },
                { label: 'Facturation', value: 'Facturation' }
            ]
        },

        optionsDetailTypeMission: () => {
            return [
                { label: 'LMNP', value: 'LMNP' },
                { label: 'LMP', value: 'LMP' }
            ]
        },

        optionsCivilite: () => {
            return [
                { label: '', value: null },
                { label: 'M.', value: 'M.' },
                { label: 'Mlle', value: 'Mlle' },
                { label: 'Mme', value: 'Mme' },
                { label: 'Dr', value: 'Dr' },
                { label: 'Me', value: 'Me' },
            ]
        },

        optionsModeDetention: () => {
            return [
                { value: 'EI',         label: 'EI' },
                { value: 'Société',    label: 'Société' },
                { value: 'Indivision', label: 'Indivision' },
            ]
        },

        optionsEspaceProfessionnel: () => {
            return [
                { value: 1, label: 'Oui' },
                { value: 0, label: 'Non' },
                { value: 2, label: 'En attente de création' },
                { value: 3, label: 'En attente de code' },
                { value: 4, label: 'En attente de suppléant' },
            ]
        },

        optionsMotifsSorties: () => {
            return [
                {label: 'autre',                         value: 'autre'},
                {label: 'arrêt d\'activité',             value: 'arrêt activité'},
                {label: 'cession',                       value: 'cession'},
                {label: 'décès',                         value: 'décès'},
                {label: 'mécontentement',                value: 'mécontentement'},
                {label: 'rapprochement géographique',    value: 'rapprochement géographique'},
                {label: 'regroupement de comptabilité',  value: 'regroupement de comptabilité'},
                {label: 'tarif',                         value: 'tarif'},
            ]
        },

        retroSibluDefaultMontant: () => {
            return { annee_n: 100, annee_n_plus_1: 50 }
        },

        optionsLogicielCompta: () => {
            return [
                { value: 'pennylane', label: 'PennyLane' },
                { value: 'cegid', label: 'Cegid' },
            ]
        },

        optionsPack: () => {
            return [
                { value: 'collaboratif', label: 'Collaboratif' },
                { value: 'essentiel', label: 'Essentiel' }
            ]
        },

        logicielComptaMapping: () => {
            return {
                pennylane: [],
                cegid: [1, 2, 3, 4],
            }
        },
    }
}
